"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NativeInput = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./NativeInput.css");
var _cdsCommon = require("@cbhq/cds-common");
var _useSpacingStyles = require("../hooks/useSpacingStyles");
var _tokens = require("../tokens");
var _textStyles = require("../typography/textStyles");
var _linaria = require("../utils/linaria");
const _excluded = ["containerSpacing", "testID", "align", "onFocus", "onPress", "onBlur", "onKeyDown", "onChange", "accessibilityLabel", "accessibilityHint", "compact"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const nativeInputBaseStyle = "cds-nativeInputBaseStyle-n1l8ztqg";
const NativeInput = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)(function NativeInput(_ref, ref) {
  let containerSpacing = _ref.containerSpacing,
    testID = _ref.testID,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'start' : _ref$align,
    onFocus = _ref.onFocus,
    onPress = _ref.onPress,
    onBlur = _ref.onBlur,
    onKeyDown = _ref.onKeyDown,
    onChange = _ref.onChange,
    accessibilityLabel = _ref.accessibilityLabel,
    accessibilityHint = _ref.accessibilityHint,
    compact = _ref.compact,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const defaultContainerSpacing = (0, _useSpacingStyles.useSpacingStyles)({
    spacing: compact ? 1 : 2
  });
  const spectrum = (0, _cdsCommon.useSpectrum)();
  const dynamicStyles = (0, _react.useMemo)(() => {
    return {
      textAlign: align,
      colorScheme: spectrum
    };
  }, [align, spectrum]);
  return /*#__PURE__*/_react.default.createElement("input", _extends({
    ref: ref,
    "aria-describedby": accessibilityHint,
    "aria-label": accessibilityLabel,
    className: (0, _linaria.cx)(nativeInputBaseStyle, _textStyles.body, containerSpacing !== null && containerSpacing !== void 0 ? containerSpacing : defaultContainerSpacing),
    "data-testid": testID,
    onBlur: onBlur,
    onChange: onChange,
    onClick: onPress,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    style: dynamicStyles,
    tabIndex: 0
  }, props));
}));
exports.NativeInput = NativeInput;